import { ApiClient } from './client.js'
import { SHARED_PLAYLISTS } from './resources.js'

const client = new ApiClient()

export default {
  retrieve (privateId) {
    return client.get(`${SHARED_PLAYLISTS}${privateId}/`)
  }
}
